import React from 'react';
import { AGING_COLORS, appendOrderStatusParams } from '../../constants';
import PeriodTable from './PeriodTable';

const AGING_FILTER_MAP = {
  '1_30': 'days_overdue_min=1&days_overdue_max=30',
  '31_60': 'days_overdue_min=31&days_overdue_max=60',
  '61_90': 'days_overdue_min=61&days_overdue_max=90',
  '90_plus': 'days_overdue_min=91',
};

const OverdueAgingSection = ({ data, selectedStatuses }) => {
  const buildFilterParams = (period) => {
    const baseParams = `overdue=true&${AGING_FILTER_MAP[period.period]}`;
    return appendOrderStatusParams(baseParams, selectedStatuses);
  };

  return (
    <PeriodTable
      title="Overdue Aging"
      emptyMessage="No overdue data available"
      data={data}
      colorMap={AGING_COLORS}
      buildFilterParams={buildFilterParams}
    />
  );
};

export default OverdueAgingSection;
